module.exports = __webpack_public_path__ + "img/sme.f783850e.svg";